<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div class="container-client">
    <div class="header">
      <h1 class="title">{{'EDIT_CLIENT' | translate}}</h1>
      <app-back-arrow [route]="'/clients'"></app-back-arrow>
    </div>
    <div class="form-card">
      <div class="loading" *ngIf="loading || !isClientLoaded">
        <div class="spinner-border" role="status"></div>
      </div>
      <form *ngIf="!loading && isClientLoaded" #editClientFormContainer [formGroup]="clientForm" (ngSubmit)="updateClient()" class="content compact-form client-form-grid">
        <section class="form-section">
          <h2 class="section-title">{{ 'PERSONAL_DATA' | translate }}</h2>
          <div class="section-grid">
            <div class="form-field">
              <label class="form-label is-required" for="firstName">{{"NAME" | translate}}</label>
              <input class="form-control" id="firstName" formControlName="firstName" type="text" [class.is-invalid]="clientForm.get('firstName')?.invalid && clientForm.get('firstName')?.touched">
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('firstName')?.hasError('required') && clientForm.get('firstName')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('NAME' | translate) } }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('firstName')?.hasError('minlength') && clientForm.get('firstName')?.touched">
                {{ 'CLIENT_FIELD_MINIMUM_LENGTH' | translate:{ field: ('NAME' | translate), length: 2 } }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label is-required" for="lastName">{{"LAST_NAME" | translate}}</label>
              <input class="form-control" id="lastName" formControlName="lastName" type="text" [class.is-invalid]="clientForm.get('lastName')?.invalid && clientForm.get('lastName')?.touched">
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('lastName')?.hasError('required') && clientForm.get('lastName')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('LAST_NAME' | translate) } }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('lastName')?.hasError('minlength') && clientForm.get('lastName')?.touched">
                {{ 'CLIENT_FIELD_MINIMUM_LENGTH' | translate:{ field: ('LAST_NAME' | translate), length: 2 } }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="gender">{{"GENDER" | translate}}</label>
              <div class="radio-row">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="genderMale" formControlName="gender" value="male">
                  <label class="form-check-label" for="genderMale">{{"MALE" | translate}}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="genderFemale" formControlName="gender" value="female">
                  <label class="form-check-label" for="genderFemale">{{"FEMALE" | translate}}</label>
                </div>
              </div>
            </div>

            <div class="form-field date-range">
              <label class="form-label" for="bornDate">{{'BIRTH_DATE' | translate}}</label>
              <mat-form-field appearance="fill" class="w-100 client-date-field">
                <mat-label>{{ 'CHOOSE_DATE' | translate }}</mat-label>
                <input matInput id="bornDate" [matDatepicker]="bornDatePicker" formControlName="bornDate" [max]="bornDateMaxDate" [class.is-invalid]="clientForm.get('bornDate')?.invalid && clientForm.get('bornDate')?.touched"/>
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="bornDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #bornDatePicker></mat-datepicker>
              </mat-form-field>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('bornDate')?.hasError('invalidDate') && clientForm.get('bornDate')?.touched">
                {{ 'INVALID_BIRTH_DATE' | translate }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('bornDate')?.hasError('futureDate') && clientForm.get('bornDate')?.touched">
                {{ 'FUTURE_BIRTH_DATE_NOT_ALLOWED' | translate }}
              </div>
            </div>
          </div>
        </section>

        <section class="form-section">
          <h2 class="section-title">{{ 'CONTACT' | translate }} / {{'DOCUMENT' | translate}}</h2>
          <div class="section-grid contact-grid">
            <div class="form-field">
              <label class="form-label is-required" for="email">{{"EMAIL" | translate}}</label>
              <input class="form-control" id="email" formControlName="email" type="email" [class.is-invalid]="clientForm.get('email')?.invalid && clientForm.get('email')?.touched">
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('email')?.hasError('required') && clientForm.get('email')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('EMAIL' | translate) } }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('email')?.hasError('email') && clientForm.get('email')?.touched">
                {{ 'INVALID_EMAIL_FORMAT' | translate }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="phone">{{"PHONE" | translate}}</label>
              <app-international-phone-input inputId="phone" formControlName="phone"></app-international-phone-input>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('phone')?.hasError('required') && clientForm.get('phone')?.touched">
                {{ 'PHONE_REQUIRED' | translate }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('phone')?.hasError('phoneInvalid') && clientForm.get('phone')?.touched">
                {{ 'INVALID_PHONE_FORMAT' | translate }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('phone')?.hasError('countryCodeRequired') && clientForm.get('phone')?.touched">
                {{ 'COUNTRY_CODE_REQUIRED' | translate }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label is-required" for="documentType">{{'DOCUMENT_TYPE' | translate}}</label>
              <select class="form-select" id="documentType" formControlName="documentType" [class.is-invalid]="clientForm.get('documentType')?.invalid && clientForm.get('documentType')?.touched">
                <option value="" disabled>{{'SELECT_DOCUMENT_TYPE' | translate}}</option>
                <option value="ID">{{'ID_NUMBER' | translate}}</option>
                <option value="Passport">{{'PASSPORT' | translate}}</option>
                <option value="DIMEX">DIMEX</option>
                <option value="other">{{'OTHER_IDENTIFICATION' | translate}}</option>
              </select>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('documentType')?.hasError('required') && clientForm.get('documentType')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('DOCUMENT_TYPE' | translate) } }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label is-required" for="nationalId">
                {{ clientForm.get('documentType')?.value === 'Passport' ? ('PASSPORT' | translate) : (clientForm.get('documentType')?.value === 'DIMEX' ? 'DIMEX' : (clientForm.get('documentType')?.value === 'other' ? ('OTHER_IDENTIFICATION' | translate) : ('ID_NUMBER' | translate))) }}
              </label>
              <input class="form-control" type="text" id="nationalId" formControlName="nationalId" [attr.placeholder]="placeholderText" [disabled]="!clientForm.get('documentType')?.value" [ngClass]="{'border border-red-500': nationalIdInvalid}" [class.is-invalid]="(clientForm.get('nationalId')?.invalid && clientForm.get('nationalId')?.touched) || nationalIdInvalid" />
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('nationalId')?.hasError('required') && clientForm.get('nationalId')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ID_NUMBER' | translate) } }}
              </div>
              <div *ngIf="nationalIdInvalid" class="invalid-feedback d-block">
                {{ 'INVALID_FORMAT' | translate:{ type: (clientForm.get('documentType')?.value === 'Passport' ? ('PASSPORT' | translate) : (clientForm.get('documentType')?.value === 'DIMEX' ? 'DIMEX' : (clientForm.get('documentType')?.value === 'other' ? ('OTHER_IDENTIFICATION' | translate) : ('ID_NUMBER' | translate)))) } }}
              </div>
            </div>
          </div>
        </section>

        <section class="form-section">
          <h2 class="section-title">{{ 'ACCESS' | translate }} / {{ 'ADDITIONAL_CONFIGURATION' | translate }}</h2>
          <div class="access-config-grid">
            <div class="form-field password-actions-column" *ngIf="!clientForm.get('username')?.value">
              <label class="form-label" for="password">{{"PASSWORD" | translate}}</label>
              <div class="pool-register">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" formControlName="password" [class.is-invalid]="clientForm.get('password')?.invalid && clientForm.get('password')?.touched">
                <div class="password-actions">
                  <button type="button" class="btn btn-primary" [disabled]="clientForm.get('password')?.disabled" (click)="generatePassword()">{{"GENERATE" | translate}}</button>
                  <button type="button" class="btn btn-info" [disabled]="clientForm.get('password')?.disabled" (click)="togglePasswordVisibility()">{{ showPassword ? ('HIDE' | translate) : ('SHOW' | translate) }}</button>
                  <button type="button" class="btn btn-info" [disabled]="clientForm.get('password')?.disabled || !clientForm.get('password')?.value" (click)="copyPassword()">{{ 'COPY' | translate }}</button>
                </div>
                <div class="copy-feedback" *ngIf="passwordCopied">{{ 'COPIED' | translate }}</div>
                <div *ngIf="clientForm.get('password')?.touched && clientForm.get('password')?.errors as errors" class="password-errors-overlay">
                  <div *ngIf="errors?.['passwordStrength']?.hasUpperCase === false" class="error-message">{{ 'PASSWORD_ERROR_UPPERCASE' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.hasLowerCase === false" class="error-message">{{ 'PASSWORD_ERROR_LOWERCASE' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.hasNumber === false" class="error-message">{{ 'PASSWORD_ERROR_NUMBER' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.hasSpecialChar === false" class="error-message">{{ 'PASSWORD_ERROR_SPECIAL_CHAR' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.isValidLength === false" class="error-message">{{ 'PASSWORD_MINIMUM_LENGTH' | translate }}</div>
                  <div *ngIf="errors?.['required']" class="error-message">{{ 'PASSWORD_REQUIRED' | translate }}</div>
                </div>
              </div>
            </div>

            <div class="switches-column">
              <label class="switch-item" for="isPoolRegister">
                <input class="form-check-input" id="isPoolRegister" formControlName="isPoolRegister" type="checkbox">
                <span>{{ 'ENABLE_ONLINE_PURCHASES' | translate }}</span>
              </label>
              <label class="switch-item">
                <mat-slide-toggle id="isVerifiedClient" formControlName="isVerifiedClient" class="switch"></mat-slide-toggle>
                <span>{{'ONLY_VERIFIED_USERS' | translate}}</span>
              </label>
            </div>

            <div class="form-field">
              <label class="form-label is-required" for="loginMethod">{{ 'LOGIN_METHOD' | translate }}</label>
              <select class="form-select" id="loginMethod" formControlName="loginMethod" [class.is-invalid]="clientForm.get('loginMethod')?.invalid && clientForm.get('loginMethod')?.touched">
                <option *ngFor="let option of loginMethodOptions" [value]="option.value">
                  {{ option.labelKey | translate }}
                </option>
              </select>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('loginMethod')?.hasError('required') && clientForm.get('loginMethod')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('LOGIN_METHOD' | translate) } }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="clientSubscription">{{'SUBSCRIPTION' | translate}}</label>
              <select class="form-select" id="clientSubscription" formControlName="clientSubscription">
                <option value="">{{'NO_SUBSCRIPTION' | translate}}</option>
                <option *ngFor="let sub of clientSubscriptions" [value]="sub.clientSubscriptionId">{{sub.clientSubscriptionName}}</option>
              </select>
            </div>

            <div class="form-field">
              <label class="form-label" for="shopCompanyId">{{'ASSOCIATED_COMPANY' | translate}}</label>
              <select class="form-select" id="shopCompanyId" formControlName="shopCompanyId">
                <option [ngValue]="null">{{'NO_ASSOCIATED_COMPANY' | translate}}</option>
                <option *ngFor="let company of shopCompanies" [ngValue]="company.shopCompanyId">
                  {{ company.companyName }}
                </option>
              </select>
            </div>

            <div class="form-field date-range" *ngIf="[4, 12].includes(themingService.shopTheming[0].shopId)">
              <label class="form-label" for="">{{'REGISTRATION_DATE' | translate}}</label>
              <mat-form-field appearance="fill">
                <mat-label>{{ 'CHOOSE_DATE' | translate }}</mat-label>
                <input matInput [matDatepicker]="registrationDatePicker" formControlName="clientRegistrationDate"/>
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="registrationDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #registrationDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </section>
        <div class="create-btn">
          <button class="btn primary-btn" type="submit">{{ 'UPDATE_CLIENT' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</div>


<div class="container benficiariesContainer">
  <div class="form-card">
    <form [formGroup]="beneficiaryForm" (ngSubmit)="createBeneficiaries()">
      <div class="content row">
        <div class="loading" *ngIf="loadingBeneficiaries">
        <div class="spinner-border" role="status"></div>
      </div>
      <div class="row" *ngIf="!loadingBeneficiaries">
        <div class="title">
          <span>{{'CREATE_BENEFICIARIES' | translate}}</span>
        </div>
        <div class="column col-md-4">
          <div class="group-select">
            <label class="form-label" for="">{{'RELATIONSHIP' | translate}}</label>
            <select class="custom-select w-100" formControlName="beneficiaryRelationship"
              (change)="onChangeRelationship($event)">
              <option value="Titular">{{'HEADLINE' | translate}}</option>
              <option value="Conyuge">{{'SPOUSE' | translate}}</option>
              <option value="Unión Libre">{{'DOMESTIC_PARTNERSHIP' | translate}}</option>
              <option value="Padre">{{'FATHER' | translate}}</option>
              <option value="Madre">{{'MOTHER' | translate}}</option>
              <option value="Hijo">{{'SON' | translate}}</option>
              <option value="Hija">{{'DAUGHTER' | translate}}</option>
              <option value="Suegra">{{'MOTHER_IN_LAW' | translate}}</option>
              <option value="Suegro">{{'FATHER_IN_LAW' | translate}}</option>
              <option value="Perro">{{'DOG' | translate}}</option>
              <option value="Gato">{{'CAT' | translate}}</option>
              <option value="Otro">{{'OTHER' | translate}}</option>
            </select>
          </div>
        </div>
        <div class="column col-md-4">
          <label class="form-label" for="">{{ 'NAME' | translate }}</label>
          <input class="form-control" id="name" formControlName="beneficiaryName" type="text" />
          <div
            *ngIf="beneficiaryForm.get('beneficiaryName')?.invalid && (beneficiaryForm.get('beneficiaryName')?.dirty || beneficiaryForm.get('beneficiaryName')?.touched)"
            class="text-danger">
            <div *ngIf="beneficiaryForm.get('beneficiaryName')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
            </div>
          </div>
        </div>
        <div class="column col-md-4" *ngIf="this.validRelationships.includes(currentRelationship)">
          <label class="form-label" for=""
            *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'ANIMAL_BREED' | translate
            }}</label>
          <input class="form-control" id="beneficiaryBreed" formControlName="beneficiaryBreed" type="text" />
        </div>
        <div class="column col-md-4" *ngIf="!this.validRelationships.includes(currentRelationship)">
          <label class="form-label" for="">{{'LAST_NAME' | translate}}</label>
          <input class="form-control" id="lastName" formControlName="beneficiaryLastName" type="text" />
          <div
            *ngIf="beneficiaryForm.get('beneficiaryLastName')?.invalid && (beneficiaryForm.get('beneficiaryLastName')?.dirty || beneficiaryForm.get('beneficiaryLastName')?.touched)"
            class="text-danger">
            <div *ngIf="beneficiaryForm.get('beneficiaryLastName')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
            </div>
          </div>
        </div>
        <div class="column col-md-4" *ngIf="!this.validRelationships.includes(currentRelationship)">
          <div class="group-select">
          <label class="form-label">{{ 'DOCUMENT_TYPE' | translate }}</label>
          <select class="custom-select w-100" formControlName="beneficiaryDocumentType">
            <option value="" disabled selected>{{ 'SELECT_DOCUMENT_TYPE' | translate }}</option>
            <option value="ID">{{'ID_NUMBER' | translate}}</option>
            <option value="Passport">{{ 'PASSPORT' | translate }}</option>
              <option value="DIMEX">DIMEX</option>
          </select>
        </div>
        </div>
        <div class="column col-md-4" *ngIf="!this.validRelationships.includes(currentRelationship)">
          <label class="form-label" for="">
            {{ beneficiaryForm.get('beneficiaryDocumentType')?.value === 'Passport' ? ('PASSPORT' | translate) :
            (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'DIMEX' ? 'DIMEX' : ('ID_NUMBER' | translate)) }}
        </label>
          <input
            class="form-control"
            id="beneficiaryNationalId"
            type="text"
            formControlName="beneficiaryNationalId"
            [attr.placeholder]="beneficiaryForm.get('beneficiaryDocumentType')?.value === 'Passport' ? 'Ej: A12345678900' : (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'DIMEX' ? 'Ej: 12345678901' : 'Ej: 123456789')"
            [disabled]="!beneficiaryForm.get('beneficiaryDocumentType')?.value"
            (input)="validateBeneficiaryNationalId()"
            [ngClass]="{ 'border border-red-500': nationalIdInvalid }"
            />
            <p *ngIf="nationalIdInvalid" class="text-sm text-red-500 mt-1">
            {{ 'INVALID_FORMAT' | translate:{type: (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'Passport' ? ('PASSPORT' | translate) : (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'DIMEX' ? 'DIMEX' : ('ID_NUMBER' | translate)))} }}
            </p>
          <div
            *ngIf="beneficiaryForm.get('beneficiaryNationalId')?.invalid && (beneficiaryForm.get('beneficiaryNationalId')?.dirty || beneficiaryForm.get('beneficiaryNationalId')?.touched)"
            class="text-danger">
            <div *ngIf="beneficiaryForm.get('beneficiaryNationalId')?.errors?.['required']">{{'FIELD_REQUIRED' |
              translate}}</div>
          </div>
        </div>
        <div class="column col-md-4" *ngIf="this.validRelationships.includes(currentRelationship)">
          <label class="form-label" for=""
            *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'ANIMAL_COLOR' | translate
            }}</label>
          <input class="form-control" id="beneficiaryColor" formControlName="beneficiaryColor" type="text" />
        </div>
        <div class="column col-md-4">
          <label class="form-label" for=""
            *ngIf="!this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'EMAIL' | translate
            }}</label>
          <label class="form-label" for=""
            *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'EMAIL_PERSON_IN_CHARGE' |
            translate }}</label>
          <input class="form-control" id="beneficiaryEmail" formControlName="beneficiaryEmail" type="text" />
        </div>
        <div class="column col-md-4">
          <label class="form-label" for=""
            *ngIf="!this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'PHONE' | translate
            }}</label>
          <label class="form-label" for=""
            *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'PHONE_PERSON_IN_CHARGE' |
            translate }}</label>
          <input class="form-control" id="beneficiaryPhone" formControlName="beneficiaryPhone" type="text" />
        </div>
        <div class="column col-md-4">
          <label class="form-label" for="">{{ 'GENDER' | translate }}</label>
          <div class="">
            <div class="form-check form-check-inline">
              <input class="form-check-input" formControlName="beneficiaryGender" type="radio" id="male"
                value="male" />
              <label class="form-check-label" for="male"
                *ngIf="!this.validRelationships.includes(currentRelationship)">{{ 'MALE' | translate }}</label>
              <label class="form-check-label" for="male"
                *ngIf="this.validRelationships.includes(currentRelationship)">{{ 'MALE_ANIMAL' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" formControlName="beneficiaryGender" type="radio"
                id="female" value="female" />
              <label class="form-check-label" for="female"
                *ngIf="!this.validRelationships.includes(currentRelationship)">{{ 'FEMALE' | translate }}</label>
              <label class="form-check-label" for="female"
                *ngIf="this.validRelationships.includes(currentRelationship)">{{ 'FEMALE_ANIMAL' | translate
                }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" formControlName="beneficiaryGender" type="radio"
                id="not-indicate" value="" />
              <label class="form-check-label" for="not-indicate">{{'NOT_INDICATE' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="column col-md-4 date-range">
          <label class="form-label m-0" for="">{{'BORN_DATE' | translate}}</label>
          <div>
            <mat-form-field appearance="fill">
              <mat-label>Choose a date</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="beneficiaryBornDate" />
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="column col-md-4">
          <label class="label-select" for="">{{'PROVINCE' | translate}}</label>
            <select class="custom-select" formControlName="selectedProvinciaId" (change)="onProvinciaChange($event)">
              <option value="" disabled selected>{{'SELECT_PROVINCE' | translate}}</option>
              <option *ngFor="let provincia of provincias" [value]="provincia.id">{{ provincia.name }}</option>
            </select>
        </div>
        <div class="column col-md-4">
          <label class="label-select" for="">{{'CANTON' | translate}}</label>
            <select class="custom-select" formControlName="selectedCantonId" (change)="onCantonChange($event)">
              <option value="" disabled selected>{{'SELECT_CANTON' | translate}}</option>
              <option *ngFor="let canton of cantones" [value]="canton.id">{{ canton.name }}</option>
            </select>
        </div>
        <div class="column col-md-4">
          <label class="label-select" for="">{{'DISTRICT' | translate}}</label>
          <select class="custom-select" formControlName="selectedDistritoId" (change)="onDistritoChange($event)">
            <option value="" disabled selected>{{'SELECT_DISTRICT' | translate}}</option>
            <option *ngFor="let distrito of distritos" [value]="distrito.id">{{ distrito.name }}</option>
          </select>
        </div>
        <div class="column col-md-12">
          <label class="form-label d-flex align-items-center gap-1" for="address-textarea">
            {{'ADDRESS' | translate}}
            <span class="tooltip-icon-wrapper" *ngIf="[12].includes(themingService.shopTheming[0].shopId)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#007bff" viewBox="0 0 16 16">
                <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"/>
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .877-.252 1.002-.598l.088-.416c.066-.308.118-.438.288-.47l.451-.082.082-.38-1.293-.287.738-3.468zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
              <div class="tooltip-bubble">
                {{'USER_ADDRESS_TOOLTIP' | translate}}
              </div>
            </span>
          </label>

          <textarea
            id="address-textarea"
            class="form-control"
            formControlName="beneficiaryAddress"
            style="resize: none;"
            rows="5">
          </textarea>
        </div>
      </div>
      </div>
      <div class="btn-box row" *ngIf="!loadingBeneficiaries">
        <button class="btn btn-outline-secondary submit-btn" type="submit">{{'CREATE_BENEFICIARY' | translate}}</button>
      </div>
    </form>
  </div>
</div>

<div class="modal beneficiary-modal-dialog" id="successBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'BENEFICIARY_SUCCESSFULLY_CREATED' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger confirm-btn" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade product-modal-body" id="requiredBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{ 'ALL_FIELDS_REQUIRED' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal beneficiary-modal-dialog" id="errorBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal beneficiary-modal-dialog" id="errorTwoBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'BENEFICIARIES_DUPLICATE' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal client-confirm-modal" id="successEditClientModal" tabindex="-1">
  <div class="modal-dialog client-modal-dialog" role="document">
    <div class="modal-content client-modal-content">
      <div class="modal-body client-modal-body">
        <h3 class="text-center">{{"SUCCESS" | translate}}</h3>
        <p class="text-center">{{ 'CLIENT_UPDATED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="requiredEditClientModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
        <div class="modal-body error-modal-body">
          <h3 class="text-center">{{"ERROR" | translate}}</h3>
          <p class="text-center">{{ 'COMPLETE_REQUIRED_FIELDS' | translate }}</p>
          <p class="text-center">{{ 'PLEASE_REVIEW_THESE_FIELDS' | translate }}</p>
          <h4 class="required-fields-title">{{ 'REQUIRED_FIELDS_DETAIL_TITLE' | translate }}</h4>
          <ul class="invalid-fields-list">
            <li *ngFor="let field of invalidClientFields">{{ field.labelKey | translate }}</li>
          </ul>
        </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal client-confirm-modal fade" id="errorEditClientModal" tabindex="-1">
  <div class="modal-dialog client-modal-dialog" role="document">
    <div class="modal-content client-modal-content">
      <div class="modal-body client-modal-body">
        <h3 class="text-center">{{"ERROR" | translate}}</h3>
        <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{"CLOSE" | translate}}</button>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
